var map = {
	"./Design1.png": 7184,
	"./Design10.png": 5026,
	"./Design11.png": 6155,
	"./Design12.png": 4864,
	"./Design13.png": 1113,
	"./Design14.png": 1718,
	"./Design15.png": 735,
	"./Design16.png": 6244,
	"./Design17.png": 2925,
	"./Design18.png": 6330,
	"./Design19.png": 1539,
	"./Design2.png": 2219,
	"./Design3.png": 6866,
	"./Design4.png": 8429,
	"./Design5.png": 2276,
	"./Design6.png": 5839,
	"./Design7.png": 7750,
	"./Design8.png": 9233,
	"./Design9.png": 9288
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5410;